export const APP_FILE_AUTOMATION= "/settings/automation";
export const APP_FILE_MANAGE_AUTOMATION= "/settings/automation/manage-automation";
